import Cookies from 'js-cookie';
import { getReviewJSONLdData } from '../../../Utils/helper';
import { addTocartBogoHandler } from '../../../Utils/productAction';

export const getProductIds = (data) => {
  let cardIds = '';
  data?.forEach((element, index) => {
    let id = element?._id || element?.id;
    cardIds = cardIds ? cardIds + ',' + id : id;
  });
  return cardIds;
};

export const reviewDataHandler = (reviewDataData) => {
  const { content } = getReviewJSONLdData(reviewDataData);
  const {
    featureRatingData,
    videos,
    user_review_images,
    totalReviews,
    avgRating,
    ratingCount,
  } = reviewDataData?.data;
  const reviewdata = {
    data: {
      featureRatingData: featureRatingData ? featureRatingData : {},
      videos: videos ? videos : [],
      user_review_images: user_review_images ? user_review_images : [],
      totalReviews: totalReviews ? totalReviews : '',
      avgRating: avgRating ? avgRating : '',
      ratingCount: ratingCount ? ratingCount : '',
      content: content,
    },
  };
  return reviewdata;
};
export const removeNonOfferItems = (offerCartData) => {
  const productIds = getProductIds(offerCartData?.productList);
  const cartItems = Cookies.get('cart_items');
  const array = cartItems?.split(',');
  const produtIdsArray = productIds?.split(',');
  let finalArray = [];
  const func = (ele) => {
    if (produtIdsArray?.indexOf(ele) !== -1) {
      finalArray.push(ele);
    }
  };
  array?.filter((element) => func(element));
  Cookies.set('cart_items', finalArray.join(','), '/');
};

export const selectProductHandler = async (product_id, offerCartData) => {
  const productId = Number.isInteger(product_id)
    ? JSON.stringify(product_id)
    : product_id;
  const params = {
    productId: productId,
    ids: getProductIds(offerCartData?.productList || offerCartData),
    add: false,
    less: false,
    addToCart: false,
    isFirstTime: false,
    selectProduct: true,
    selectedProductId: productId,
  };
  const diaperOfferData = await addTocartBogoHandler(params);
  return diaperOfferData;
};
